import React from 'react'
import Letter from './Letter/Letter'
import styles from './Alphabet.module.css'
import { connect } from 'react-redux'

const Alphabet = props => {
  const letters = props.alphabet.map((letter, letterIndex) => {
    return (
      <Letter 
        key={letter.id}
        letterIndex={letterIndex}
        letter={letter.letter}
        clickedLetter={letter.clickedLetter}
        correctGuess= {letter.correctGuess}
        clicked={props.clicked}
      />
    )
  })

  return (
    <section className={styles.Alphabet}>
      {letters}
    </section>
  )
}

const mapStateToProps = state => {
  return {
    alphabet: state.puzzle.alphabet
  }
}

export default connect(mapStateToProps)(Alphabet)